var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@fluentui/react";
var Box = function (_a) {
    var children = _a.children, title = _a.title, className = _a.className, style = _a.style;
    var titleMarkup = title && (_jsx(Text, __assign({ className: 'capitalize font-bold py-1', variant: 'medium' }, { children: title })));
    return (_jsx("div", __assign({ className: "".concat(className, " px-2 pb-2 bg-[#f0f0f0]  w-full"), style: style }, { children: _jsxs("div", __assign({ className: 'px-2 pb-2 bg-white rounded-md' }, { children: [_jsx("div", __assign({ className: 'flex justify-start align-middle' }, { children: titleMarkup })), children] })) })));
};
export default Box;
